import { APP_CONFIG } from '../config/app.ts'
import { useAuthStore } from "../store/auth.store.ts";

const fetchUrl = ( url:string, data:object, method = 'GET' ) => {

    
   
    if ( method === 'GET' ) {
        return fetch( url );
    } else {
        return fetch( url, {
            method,
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify( data )
        });
    }
}

const fetchSinToken = ( endpoint:string, data:object, method = 'GET' ) => {

    const url = `${ APP_CONFIG.apiUrl }/${ endpoint }`;
   
    if ( method === 'GET' ) {
        return fetch( url );
    } else {
        return fetch( url, {
            method,
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify( data )
        });
    }
}

const fetchConToken = ( endpoint:string, data?:object, method = 'GET' ) => {

    const url = `${ APP_CONFIG.apiUrl }/${ endpoint }`;
    const token = useAuthStore.getState().token;
  
    
   

    if ( method === 'GET' ) {
        return fetch( url, {
            method,
            credentials: 'include',
            headers: {
                'x-token': token,
            }
        });
    } else {
        return fetch( url, {
            method,
            credentials: 'include',
            headers: {
                'Content-type': 'application/json',
                'x-token': token,
            },
            body: JSON.stringify( data )
        });
    }
}

export {
    fetchSinToken,
    fetchConToken,
    fetchUrl
}